import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';

@Component({
  selector: 'app-frma-change-history-comment',
  templateUrl: './frma-change-history-comment.component.html',
  styleUrls: ['./frma-change-history-comment.component.css']
})
export class FrmaChangeHistoryCommentComponent implements OnInit {

  comment = '';
  errors: ErrorList[] = [];
  @ViewChild('form', { read: NgForm, static: true }) form: NgForm;
  @ViewChild('frmaComment', { read: ElementRef, static: true }) frmaComment: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<FrmaChangeHistoryCommentComponent>
  ) { }

  ngOnInit(): void {
  }

  validate() {
    Object.keys((<FormGroup>this.form.form).controls).forEach(control => {
      this.form.form.get(control).markAsTouched();
    });
    this.errors = [];
    if (!this.comment) {
      this.errors.push({
        fieldName: 'Comment',
        fieldRef: this.frmaComment,
        errorMsg: ' is required.'
      });
    }
  }

  saveClick() {
    this.validate();
    if (this.errors.length == 0) {
      this.dialogRef.close(this.comment);
    }
  }

}
